import * as React from 'react';
import Glyphicon from 'source/app/presentation/Shared/Glyphicon/Glyphicon';
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { Style } from 'source/app/presentation/Shared/Styles/CSS';
import { StyleClass } from '../../../../../Shared/Styles/CSS';

export function DisplayKipsAdjustment({
	adjustmentName,
	adjustmentValue,
	icon
}: {
	adjustmentName: string;
	adjustmentValue: number;
	icon: EGlyphicon;
}) {
	const opacity = adjustmentValue === 0 ? 0.3 : 1;
	const color = GetAdjustmentColor(adjustmentValue);

	return (
		<div
			{...Style(`kipsAdjustment_${color}_${opacity}`, {
				color,
				margin: `10px`,
				opacity
			})}
		>
			<Glyphicon
				icon={icon}
				withClass={StyleClass(`displayKipsAdjustmentIcon`, {
					marginRight: `10px`
				})}
			/>
			{adjustmentName}: <strong>{adjustmentValue}₭</strong>
		</div>
	);
}

function GetAdjustmentColor(adjustmentValue: number) {
	if (adjustmentValue > 0) {
		return `yellowgreen;`;
	}

	if (adjustmentValue < 0) {
		return `coral`;
	}

	return `silver`;
}
